<template>
	<v-menu
		bottom
		min-width="200px"
		rounded
		offset-y
		left
	>
		<template v-slot:activator="{ on }">
			<v-btn
				v-on="on"
				text
				elevation="0"
				plain
				small
				color="grey"
				:ripple="false"
				:class="currentStatus.class"
				:loading="saving"
				:disabled="!canChange"
			>
				<v-tooltip top>
					<template v-slot:activator="{ on, attrs }">
						<div class="status" :class="currentStatus.class" v-bind="attrs"
						v-on="on">
							{{ $vuetify.lang.t(currentStatus.title) }} <v-icon v-if="canChange">mdi-chevron-down</v-icon>
						</div>
					</template>
					<template v-if="canChange">
						{{ $vuetify.lang.t('$vuetify.views.wall.problem.changeStatus') }}
					</template>
					<template v-else>
						{{ $vuetify.lang.t('$vuetify.views.wall.problem.cannotChange') }}
					</template>
				</v-tooltip>
			</v-btn>
		</template>
		
			<v-list>
				<v-list-item
					v-for="(status, index) in availableStatuses"
					:key="index"
					link
					class="py-0"
					@click="setStatus(status)"
				>
					{{ $vuetify.lang.t('$vuetify.views.wall.problem.changeTo') }} <div class="bold ml-1">{{ $vuetify.lang.t(status.title) }}</div>
				</v-list-item>
			</v-list>
	</v-menu>
</template>

<script>
import {mapGetters} from 'vuex';
export default {
	name: "PostDropdown",
	props: {
		status: {
			type: String,
			required: true
		},
		post: {
			type: Object,
			required: true
		}
	},
	data() {
		return {
			saving: false,
			newStatus: null
		}
	},
	computed: {
		...mapGetters({
			problemStatuses: 'dictionaries/problemStatuses'
		}),
		canChange() {
			if(this.availableStatuses.length) {
				return true;
			}
			return false;
		},
		problem() {
			return this.post.postable;
		},
		currentStatus() {
			return this.problemStatuses.find(x => x.name == this.status);
		},
		possibleSolutions() {
			return this.problem.problem_ideas.filter(x => x.is_solution);
		},
		availableStatuses() {
			return this.problemStatuses.filter(x => {
				if(x.name != this.status) {
					if(this.problem.problem_ideas.length) {
						if(this.status == 'new' && x.name == 'analyzed') {
							return true;		
						}
						else if(this.status == 'analyzed' && x.name == 'new') {
							return true;
						}
						else if(this.status == 'analyzed' && x.name == 'in_progress' && this.possibleSolutions.length) {
							return true;
						}
						else if(this.status == 'in_progress' && x.name == 'analyzed' && !this.possibleSolutions.lenght) {
							return true;
						}
						else if(this.status == 'in_progress' && x.name == 'resolved' && this.possibleSolutions.length) {
							return true;
						}
						else if(this.status == 'resolved' && x.name == 'in_progress') {
							return true;
						}
					}
					else {
						if(x.name == 'new') {
							return true;
						}
					}
					return false;
				}
				return false
			})
		}
	},
	methods: {
		async setStatus(status) {
			this.saving = true;
			const res = await this.$store.dispatch('wall/changeProblemStatus', {
				postId: this.post.id, 
				status: status.name
			});
			if(res.success) {
				console.log("OK!")
			}
			this.saving = false;
			
		}
	}
}
</script>

<style lang="scss">
	.status {
		border-radius: 20px;
		padding: 6px 12px;
		font-weight: bold;
		font-size: 12px;
		&.status-new {
			background: var(--v-grey-lighten1);
		}
		&.status-analyzed {
			color: var(--v-accent-base);
			background: var(--v-accent-lighten1);
		}
		&.status-in-progress {
			color: var(--v-accent-base);
			background: var(--v-accent-lighten2);
		}
		&.status-resolved {
			color: var(--v-success-base);
			background: var(--v-success-lighten1);
		}
	}
</style>
